const MISSING = 'missing';

export { MISSING };
